import { Component, AfterViewInit, OnDestroy, Signal, ViewChild } from '@angular/core';
import { IonRouterOutlet } from '@ionic/angular/lazy';
import { Router } from '@angular/router';
import { SocketioService } from './service/SocketService/socketio.service';
import { AuthService } from './service/AuthGuard/auth.service';
import { Capacitor } from '@capacitor/core';
import { CommonService } from './service/Common/common.service';
import { register } from 'swiper/element/bundle';
import { ThemeService } from './service/ThemeService/theme.service';
// Swoperを使うためにここで一度だけ初期化しておく必要があるらしい
register();

@Component({
  standalone: false,
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})

export class AppComponent implements AfterViewInit, OnDestroy {
  @ViewChild(IonRouterOutlet) routerOutlet!: IonRouterOutlet;
  
  private isReplacingUrl = false;
  private removeSessionExpiredListener?: () => void;
  public readonly connectionState: Signal<'connected' | 'reconnecting' | 'authenticating' | 'unavailable'>;

  constructor(
    private socketService: SocketioService,
    private authService: AuthService,
    private router: Router,
    private commonService: CommonService,
    private themeService: ThemeService,
  ) { 
    this.themeService.initialize();
    this.connectionState = this.socketService.connectionState;
    this.removeSessionExpiredListener = this.socketService.onSessionExpired(() => void this.handleSessionExpired());
  }

  ngAfterViewInit() {
    console.log( "construcot Platform: ", Capacitor.getPlatform());
    this.socketService.connect();
  }

  ngOnDestroy(): void {
    this.removeSessionExpiredListener?.();
  }

  retryConnection(): void {
    this.socketService.reconnectNow();
  }

  connectionMessage(): string {
    switch (this.connectionState()) {
      case 'authenticating': return '接続を確認しています…';
      case 'unavailable': return '接続できません。ネットワークまたはサーバーの状態を確認してください。';
      default: return 'サーバーに再接続しています…';
    }
  }

  private async handleSessionExpired(): Promise<void> {
    this.authService.markUnauthenticated();
    await this.router.navigateByUrl('/login/%2Ftabs%2Ftab1?reason=session-expired', { replaceUrl: true });
  }

}
